var ctx = $('#myChart');
	if (ctx.length) {
		var myChart = new Chart(ctx, {
		  type: 'line',
		  data: {
		    labels: ["1970", "1975", "1980", "1985", "1990", "1995", "2000", "2005", "2010", "2015"],
		    datasets: [
			    {
			      label: 'Total National Health Expenditures',
			      data: [ 74.56, 133.28, 255.33, 442.9, 721.39, 1021.64, 1369.17, 2023.83, 2598.6, 3205.91],
				  backgroundColor: '#1c4063',
		      	  borderWidth: 1
		    	},
					{
						label: 'Constant 2015 Dollars',
						backgroundColor: '#4ac8ec',
						data: [377.51, 496.58, 656.38, 884.17, 1207.8, 1509.07, 1856.36, 2472.86, 2880.11, 3297.53],
						borderWidth: 1
					}
				]
		  },
		  options: {
		  	scales: {
		    	yAxes: [{
		        ticks: {
							reverse: false
		        }
		      }]
		    }
		  }
		});
	}
